'use strict';

import * as types from './types';

export const fetchAttempts = (companyId, jobId, hashLocationId) => ({
	type: types.FETCH_ATTEMPTS,
	meta: {
		async: true,
		endPoint: `/attempts/${ companyId }/${ jobId }/${ hashLocationId }`,
		method: 'GET',
		params: { companyId, jobId, hashLocationId },
	}
});

export const fetchUserAttempts = (username, tzOffset, date) => ({
	type: types.FETCH_USER_ATTEMPTS,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/getUserAttempts`,
		method: 'GET',
		params: {
			tzOffset
		},
		body: {
			username,
			date
		}
	}
});

export const fetchUserDailyAttempts = (username, tzOffset, date) => ({
	type: types.FETCH_USER_DAILY_ATTEMPTS,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/getUserDailyAttempts`,
		method: 'GET',
		params: {
			tzOffset
		},
		body: {
			username,
			date
		}
	}
});

export const fetchUserWeeklyAttempts = (username, date, tzOffset, tzMinutes) => ({
	type: types.FETCH_USER_WEEKLY_ATTEMPTS,
	meta: {
		async: true,
		endPoint: `/user/${ username }/getUserWeeklyAttempts`,
		method: 'GET',
		params: {
			date,
			tzOffset,
			tzMinutes,
		},
		body: {
			username,
			date
		}
	}
});

export const postAttempt = ({
	username,
	date,
	jobId,
	locationId,
	details,
	geo,
}) => ({
	type: types.POST_ATTEMPT,
	meta: {
		async: true,
		endPoint: `/attempts/create`,
		method: 'POST',
		body: { jobId, locationId, details, geo },
		params: { username, date },
	},
});

export const postEditAttempt = (
	username,
	attemptId,
	data,
) => ({
	type: types.POST_EDIT_ATTEMPT,
	meta: {
		async: true,
		endPoint: `/attempts/edit`,
		method: 'POST',
		body: { attemptId, data },
		params: { username },
	},
});

export const postDeleteAttempt = (username, date, attemptId) => ({
	type: types.POST_DELETE_ATTEMPT,
	meta: {
		async: true,
		endPoint: `/attempts/delete`,
		method: 'POST',
		body: { username, date, attemptId }
	}
});
